import {QuantityTypeTemplate} from "./QuantityTypeTemplate";

export const TASK_QUANTITY_TYPE_OTHER = 'Anders'
export class QuantityType {
  constructor(
    public readonly id: string,
    public readonly name: string,
    public readonly gradient: number|null,
    public readonly intercept: number|null,
    public readonly enabled: boolean,
    public readonly defaultColor: string|null,
    public readonly descriptionTemplate: string[],
    public readonly hideArea: boolean,
    public readonly thicknessUnit: "cm"|"mm"|"geen",
    public readonly shouldGenerateWorkorder: boolean,
    public readonly countsForManDaySheet: boolean,
    public readonly templates: QuantityTypeTemplate[],
  ) {}

  static fromJson(json: any): QuantityType {
    return new QuantityType(
      json['id'],
      json['name'],
      json['gradient'],
      json['intercept'],
      json['enabled'],
      json['default_color'] ?? null,
      json['description_template'] ?? [],
      json['hide_area'],
      json['thickness_unit'],
      json['should_generate_workorder'],
      json['counts_for_man_day_sheet'] ?? true,
      (json['templates'] ?? []).map((t: any) => QuantityTypeTemplate.fromJson(t)),
    );
  }
}